import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import DashboardCard from './DashboardCard';

import { useTranslation } from 'react-i18next';
import { AtNoData } from '../../../components/AtNoData';

const FrequentProblemsChart = ({ data, isLoading }) => {
    const { t } = useTranslation();
    const safeData = data || { categories: [], totals: [] };

    const options = {
        chart: {
            type: 'bar',
            height: 300,
            style: { fontFamily: 'inherit' }
        },
        title: { text: null },
        credits: { enabled: false },
        xAxis: {
            categories: safeData.categories,
            title: { text: null },
            gridLineWidth: 0,
            lineWidth: 0
        },
        yAxis: {
            min: 0,
            title: { text: null },
            labels: { overflow: 'justify' },
            gridLineColor: '#F3F4F6'
        },
        tooltip: {
            valueSuffix: ` ${t('sentiment.charts.mentions')}`
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: { enabled: true },
                colorByPoint: true,
                colors: ['#EF4444', '#F87171', '#FCA5A5', '#FECACA', '#FEE2E2']
            }
        },
        legend: { enabled: false },
        series: [
            {
                name: t('sentiment.charts.mentions'),
                data: safeData.totals
            }
        ]
    };

    const isEmpty = safeData.categories.length === 0;

    return (
        <DashboardCard title={t('sentiment.charts.frictionTitle')} isLoading={isLoading}>
            {isEmpty && !isLoading ? (
                <AtNoData />
            ) : (
                <HighchartsReact highcharts={Highcharts} options={options} />
            )}
        </DashboardCard>
    );
};

export default FrequentProblemsChart;
